"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useUncontrolledFocus", {
    enumerable: true,
    get: function() {
        return useUncontrolledFocus;
    }
});
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
function useUncontrolledFocus() {
    (0, _useTabster.useTabster)();
    return (0, _tabster.getTabsterAttribute)({
        uncontrolled: {}
    });
}
